import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map, of } from 'rxjs';
import { BackendInterceptor } from '../../../services/backend-interceptor/backend-interceptor.service';
import { DocumentTemplatesService } from '../../../services/document-templates/document-templates.service';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';
import { UsersListConfigService } from '../../../services/users-list-config/users-list-config.service';
import { User } from '../../../state/auth/types';

@Component({
    selector: 'lib-manage-users-wrapper',
    templateUrl: './manage-users-wrapper.component.html',
    styleUrls: ['./manage-users-wrapper.component.css'],
    standalone: false
})
export class ManageUsersWrapperComponent implements OnInit {
  public usersListConfigService = inject(UsersListConfigService);
  protected modalService = inject(NgbModal);
  protected router = inject(Router);
  protected backendInterceptor = inject(BackendInterceptor);
  protected gungModalService = inject(GungModalService);

  public listUser = true;

  protected documentTemplatesService = inject(DocumentTemplatesService);

  backendBaseUrl = this.backendInterceptor.getBaseUrl();

  userTemplates$ = this.documentTemplatesService.getTemplates().pipe(
    map(templates => templates.filter(template => template.type === 'USER')),
    catchError(() => of([]))
  );


  ngOnInit() {}

  openCreateUser(): void {
    this.gungModalService.createUser({}, false).then(
      (user: User) => {
        if (!!user) {
          this.router.navigate(['/admin/users-details/' + user.username]);
        }
      },
      reason => {}
    );
  }
}
